import React from 'react';

import { buttons, colors } from '@pray/shared/components/foundations';
import Button from '@pray/shared/components/ui/Button';
import Image from '@pray/shared/components/ui/Image/Image';
import Video from '@pray/shared/components/ui/Video/Video';

import { FeatureTitle } from 'components/pages/public/components/ui/FeatureTitle';
import useAppRoutes from 'hooks/useAppRoutes';

import type { HeroSectionProps } from '../types';

const HeroSection: React.FC<HeroSectionProps> = ({ icon, tag, title, description, ctaText, heroMedia }) => {
  const appRoutes = useAppRoutes();
  return (
    <section className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-8 md:flex-row md:items-center lg:gap-20">
          <div className="flex grow animate-slide-in-left flex-col gap-4 lg:flex-1 lg:gap-8">
            <FeatureTitle title={tag} icon={icon} className="uppercase" />
            <div className="flex flex-col gap-2 text-left">
              <h1 className="text-[1.75rem] font-bold text-text-primary md:text-[2rem] md:leading-relaxed lg:text-[56px] lg:leading-[120%]">
                {title}
              </h1>
              <p className="text-base font-[450] text-text-secondary lg:text-lg">{description}</p>
            </div>
            <Button
              data-tapeventname="Hero CTA"
              variant={buttons.variant.primary}
              color={colors.pray_featured}
              className="w-max animate-slide-in-left px-6 font-medium"
              to={appRoutes.getStarted()}
            >
              {ctaText}
            </Button>
          </div>

          <div className="w-full grow animate-slide-in-right justify-self-center rounded-lg md:max-w-96 lg:w-[696px] lg:max-w-[45vw] lg:flex-1">
            {heroMedia.type === 'image' ? (
              <Image className="aspect-[600/460] size-full object-contain" src={heroMedia.src} loading="eager" />
            ) : (
              <Video playerOptions={{ autoplay: false }} videoUrl={heroMedia.src} />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
